<template>
<div class="chapter">
<div class="inner_page">
<div class="otherbooks" id="adc">
<p class="center"><span class="medium">ALSO BY NICHOLAS COLERIDGE</span><br/><br/></p>
<p class="center"><em>Tunnel Vision</em></p>
<p class="center"><em>Around the World in 78 Days</em></p>
<p class="center"><em>Shooting Stars</em></p>
<p class="center"><em>The Fashion Conspiracy</em></p>
<p class="center"><em>How I Met My Wife and Other Stories</em></p>
<p class="center"><em>Paper Tigers</em></p>
<p class="center"><em>With Friends Like These</em></p>
<p class="center"><em>Streetsmart</em></p>
<p class="center"><em>A Much Married Man</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312382582_epub_adc_r1.vue?83f2028c